// extracted by mini-css-extract-plugin
module.exports = {"slider":"slider__dGBMd"};